// DMSContent.js
export const DMSContent = {
  heroContent: {
    title: "DIGITIZE AND SIMPLIFY YOUR DOCUMENT OPERATIONS",
    description:
      "A next-generation Document Management Solution for paperless operations, smart categorization, and instant retrieval.",
    backgroundImage: "/assets/images/solution1.jpg",
  },

  footerContent: {
    backgroundColor: "#96B596",
    text: "© 2025 Tenth Corporation Inc. All Rights Reserved",
  },

  overviewCards: [
    {
      title: "Easy to Access",
      description:
        "Authorized personnel to access documents from anywhere, at any time with a network connection.",
      image: "/assets/images/EasyAccess.png",
    },
    {
      title: "Version Control",
      description:
        "Automatically tracks changes to documents and maintains a record of previous versions.",
      image: "/assets/images/VersionControl.png",
    },
    {
      title: "Collaboration",
      description:
        "Allows multiple users to collaborate on documents simultaneously",
      image: "/assets/images/Collaboration.png",
    },
    {
      title: "Automated Workflow",
      description:
        "Enables seamless and automatic publishing of vacancy and job opportunities.",
      image: "/assets/images/AutomatedWorkflow.png",
    },
  ],

  keyFeatures: [
    {
      icon: "bi-file-earmark-text",
      title: "Document Archiving",
    },
    {
      icon: "bi-search",
      title: "Advanced Search",
    },
    {
      icon: "bi-diagram-3",
      title: "Workflow Automation",
    },
    {
      icon: "bi-shield-lock",
      title: "Access Control",
    },
    {
      icon: "bi-clock-history",
      title: "Version History",
    },
    {
      icon: "bi-cloud-arrow-down",
      title: "Cloud Backup",
    },
    {
      icon: "bi-bar-chart",
      title: "Analytics & Reports",
    },
    {
      icon: "bi-gear",
      title: "System Configuration",
    },
  ],

  dmsInActionImage: "/assets/images/DMSAction.png",

  highLevelArchitecture: {
    image: "/assets/images/HighLevel.png",
  },

  uasManagement: {
    title: "User, Access, and Security Management",
    image: "/assets/images/UASManagement.png",
  },
  implementationServices: {
  title: "Implementation Services",
  image: "/assets/images/Implementation.png" 
}
};
